import { defineComponent as _defineComponent } from 'vue'
import { queries } from "@/apollo";
import { AppMode, Release, User } from "@/CodegenTypes";
import { customMoment } from "@/main";
import { first, startCase, sumBy } from "lodash";
import { formatCount } from "@/helpers/formatCount";
import { formatDollar } from "@/helpers/formatDollar";
import { printNumCountName } from "@/helpers/tt/printNumCountName";
import { canSeeTtCompanyLevel } from "@/helpers/user/canSeeTtCompanyLevel";
import { computed, reactive } from "vue";
import { useQuery } from "@vue/apollo-composable";
import { useRoute } from "vue-router/composables";
import { useTranslation } from "@/store/translation";


export default /*#__PURE__*/_defineComponent({
  __name: 'StrikeReport',
  setup(__props) {

const route = useRoute()
const { $t } = useTranslation();


const selectedStartReleaseDate = computed(() => {
  const query = route.query.startReleaseDate;
  return Array.isArray(query) ? first(query) : query;
})


const selectedEndReleaseDate = computed(() => {
  const query = route.query.endReleaseDate;
  return Array.isArray(query) ? first(query) : query;
})

const { result: meResult } = useQuery<{ me: User }>(queries.me, {}, { fetchPolicy: 'cache-first' })
const { result, loading } = useQuery<{ releases: Release[] }>(queries.releasesWithTtStrikeReports, { appMode: AppMode.Tt, dateRange: reactive({ releaseDateStart: selectedStartReleaseDate, releaseDateEnd: selectedEndReleaseDate }) })


const seeCompanyLevel = computed(() => {
  return canSeeTtCompanyLevel(meResult.value?.me);
})

const reversedReleases = computed(() => {
  const releases = result.value?.releases;
  if (!releases) return [];
  return [...releases].reverse();
})

const processedStrikeReports = computed(() => {

  const processed = reversedReleases.value.map((release) => {
    const reportRows = release.ttStrikeSummaryReports;
    const summary = {
      unit: sumBy(reportRows, (row) => row.companyUnit),
      strikeAmount: sumBy(reportRows, (row) => row.companyStrikeAmount),
      outsetAmount: sumBy(reportRows, (row) => row.outsetAmount),
    };

    return {
      releaseDate: release.releaseDate,
      rows: reportRows,
      summary,
    };
  });

  return processed;
})



function formatDate(date: string) {
  return customMoment(date).format("DD MMM YYYY");
}

function formatDatetime(date: string) {
  return customMoment(date).format("DD/MMM HH:mm:ss");
}


return { __sfc: true,route, $t, selectedStartReleaseDate, selectedEndReleaseDate, meResult, result, loading, seeCompanyLevel, reversedReleases, processedStrikeReports, formatDate, formatDatetime, startCase, formatCount, formatDollar, printNumCountName }
}

})